module.exports = __webpack_public_path__ + "img/Entia-Lineas-de-transmision-distribucion-electrica-8.41a8bcd9.webp";